import { render, staticRenderFns } from "./AccountClassEntry.vue?vue&type=template&id=067fd2c4&scoped=true"
import script from "./AccountClassEntry.vue?vue&type=script&lang=js"
export * from "./AccountClassEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067fd2c4",
  null
  
)

export default component.exports